module.exports = __webpack_public_path__ + "static/creativity-8b011660da3a586b4dfde9347e07a10e.jpg";